// Generated by ts-to-zod
import { z } from 'zod';

export const resetPasswordPayloadSchema = z.object({
  email: z.string(),
  emailType: z.string().optional(),
  adminEmail: z.string().optional(),
});
